import { render, staticRenderFns } from "./addSingleThread.vue?vue&type=template&id=06013160&scoped=true"
import script from "./addSingleThread.vue?vue&type=script&lang=js"
export * from "./addSingleThread.vue?vue&type=script&lang=js"
import style0 from "./addSingleThread.vue?vue&type=style&index=0&id=06013160&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06013160",
  null
  
)

export default component.exports